import { difference } from "lodash";

const COUNTRY_ALIASES = {
    "Hong Kong": "China",
};

export const normalizeCountry = (country) => COUNTRY_ALIASES[country] ?? country;

export const CONTINENT_LIST = [
    "North America",
    "South America",
    "Europe",
    "Middle East",
    "Asia Pacific",
    "Africa",
];

export const ALL_REGIONS = CONTINENT_LIST.map((name) => ({ id: name, value: name }));

export const doArrayValuesMatch = (arr1 = [], arr2 = []) => {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
    if (arr1.length !== arr2.length) return false;
    return !difference(arr1, arr2)?.length;
};

export const parseRegionFilterSelections = (regionFilters = []) => {
    const selectedContinents = [];
    const selectedCountries = [];
    const selectedCities = [];
    const allSelections = [];

    regionFilters?.forEach((regionFilter) => {
        const dashIndex = regionFilter.indexOf("-");
        const regionFilterType = dashIndex > -1 ? regionFilter.substring(0, dashIndex) : null;
        const regionFilterValue = dashIndex > -1 ? regionFilter.substring(dashIndex + 1) : null;
        if (!regionFilterType || !regionFilterValue) return;

        if (regionFilterType === "continent") selectedContinents.push(regionFilterValue);
        else if (regionFilterType === "country") selectedCountries.push(regionFilterValue);
        else if (regionFilterType === "city") selectedCities.push(regionFilterValue);

        allSelections.push(regionFilterValue);
    });

    return {
        selectedContinents,
        selectedCountries,
        selectedCities,
        allSelections,
        isAllSelected: doArrayValuesMatch(allSelections, CONTINENT_LIST),
    };
};

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /Mobi/i.test(userAgent) || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
};
